export const REQUEST_STATUSES = {
  PENDING: 0, 
  WAITING_RESPONSE: 1,  
  EXHAUSTED: 2, 
  ACCEPTED: 3,  
  CANCELLED: 4, 
  ABORTED: 5, 
  FINISHED: 6,  
}

// @todo create request status title map.
export const STATUSES = [
  "Pendiente",
  "Esperando Respuesta",
  "Expirado",
  "Aceptado",
  "Cancelado",
  "Cancelado por el Repartidor",
  "Finalizado",
];

export const STOP_STATUSES = {
  PENDING: 0,
  WIP: 1,
  PARTIALLY_COMPLETE: 2,
  COMPLETE: 3,
};
